var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgOmakase(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_i_29636_147259)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.36719 19.3475C3.19441 13.7239 6.75505 8.82311 11.5388 5.34752C16.3225 1.87194 22.0838 -7.0512e-08 27.9968 0V28L1.36719 19.3475Z",
    fill: "url(#paint0_linear_29636_147259)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28 56.0001C23.5813 56.0001 19.2254 54.9544 15.2883 52.9483C11.3512 50.9423 7.94477 48.0329 5.34753 44.4581C2.75029 40.8833 1.03597 36.7446 0.34473 32.3803C-0.346506 28.016 0.00497019 23.5501 1.37042 19.3477L28 28.0001L28 56.0001Z",
    fill: "url(#paint1_linear_29636_147259)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28 0C31.677 4.38479e-08 35.318 0.724242 38.7151 2.13137C42.1123 3.53851 45.199 5.60097 47.799 8.20101C50.399 10.8011 52.4615 13.8878 53.8686 17.2849C55.2758 20.682 56 24.323 56 28C56 31.677 55.2758 35.318 53.8686 38.7151C52.4615 42.1123 50.399 45.199 47.799 47.799C45.199 50.399 42.1123 52.4615 38.7151 53.8686C35.318 55.2758 31.677 56 28 56L28 28V0Z",
    fill: "url(#paint2_linear_29636_147259)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.5996 28C55.5996 12.7569 43.2431 0.400391 28 0.400391C12.7569 0.400391 0.400391 12.7569 0.400391 28C0.400391 43.2431 12.7569 55.5996 28 55.5996V56C12.536 56 0 43.464 0 28C0 12.536 12.536 0 28 0C43.464 0 56 12.536 56 28C56 43.464 43.464 56 28 56V55.5996C43.2431 55.5996 55.5996 43.2431 55.5996 28Z",
    fill: "#FFD6CC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46 28C46 37.9411 37.9411 46 28 46C18.0589 46 10 37.9411 10 28C10 18.0589 18.0589 10 28 10C37.9411 10 46 18.0589 46 28Z",
    fill: "url(#paint3_linear_29636_147259)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.5996 28C43.5996 19.3844 36.6156 12.4004 28 12.4004C19.3844 12.4004 12.4004 19.3844 12.4004 28C12.4004 36.6156 19.3844 43.5996 28 43.5996V46C18.0589 46 10 37.9411 10 28C10 18.0589 18.0589 10 28 10C37.9411 10 46 18.0589 46 28C46 37.9411 37.9411 46 28 46V43.5996C36.6156 43.5996 43.5996 36.6156 43.5996 28Z",
    fill: "#4D2A1F"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_29636_147259)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M26.5083 34C26.3384 34 26.1686 33.968 26.0149 33.9041C25.8611 33.8402 25.7155 33.7443 25.5942 33.6245L21.1771 29.0226C20.9344 28.783 20.7969 28.4634 20.7969 28.1198C20.7969 27.7763 20.9344 27.4567 21.1771 27.217C21.4198 26.9774 21.7434 26.8415 22.0913 26.8415C22.4391 26.8415 22.7627 26.9774 23.0054 27.217L26.5083 30.9161L32.9883 22.3755C33.231 22.1358 33.5546 22 33.9025 22C34.2504 22 34.574 22.1358 34.8166 22.3755C35.0593 22.6152 35.1969 22.9348 35.1969 23.2783C35.1969 23.6218 35.0593 23.9414 34.8166 24.1811L27.4225 33.6165C27.3011 33.7364 27.1636 33.8322 27.0018 33.8961C26.8481 33.9601 26.6782 33.992 26.5083 33.992V34Z",
    fill: "white"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_i_29636_147259",
    x: 0,
    y: 0,
    width: 56,
    height: 56,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.64 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_29636_147259"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_29636_147259",
    x: 19.7969,
    y: 22,
    width: 16.4004,
    height: 14,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.4 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_29636_147259"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_29636_147259",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_29636_147259",
    x1: 5.5,
    y1: 20.5,
    x2: 28,
    y2: 5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F2E4CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F2E6E6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_29636_147259",
    x1: 28,
    y1: 50.5,
    x2: 6.5,
    y2: 21,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F09336"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F06E43"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_29636_147259",
    x1: 28,
    y1: 0,
    x2: 28,
    y2: 56,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EA5D2C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EB3838"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_29636_147259",
    x1: 17,
    y1: 17,
    x2: 39,
    y2: 39,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EA5D2C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EB3838"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOmakase);
export default __webpack_public_path__ + "static/media/omakase.ce48e850dcc32e49239c54327cf7f5da.svg";
export { ForwardRef as ReactComponent };